<template>
  <div>
    <!-- 钉钉微应用 -->
    <div class="main-wrap">
      <el-tabs v-model="activeName">
        <div class="org-tree">
          <h1 class="com-title com-ht tree-title" style="padding-top: 0">
            <i></i>
            <span class="ms">
              {{
              isCreate
              ? "合同发起时的审批流程，审批通过后合同才能成功发送"
              : isSign
              ? "合同盖章时的审批流程，审批通过后合同才能成功盖章"
              : ""
              }}
            </span>
          </h1>
        </div>
        <el-tab-pane name="create">
          <!-- <span slot="label"><i class="faqi"></i>文件审批设置</span> -->
          <span slot="label">合同发起时审批</span>
          <el-row type="flex">
            <el-col :span="4">
              <el-button type="primary" size="small" plain @click="addFlow">新增钉钉审批</el-button>
            </el-col>
            <el-col :span="20" style="text-align: right">
              <el-form :inline="true" :model="filterModel" size="small">
                <el-form-item>
                  <el-input style="width: 220px" v-model="filterModel.flowName" placeholder="流程名称"></el-input>
                </el-form-item>
                <el-form-item>
                  <el-select
                    style="width: 120px"
                    v-model="filterModel.orderFlag"
                    placeholder="请选择流程"
                  >
                    <el-option label="全部" value></el-option>
                    <el-option label="顺序审批" :value="1"></el-option>
                    <el-option label="会审" :value="0"></el-option>
                  </el-select>
                </el-form-item>
                <el-form-item>
                  <el-select
                    style="width: 120px"
                    v-model="filterModel.useStatus"
                    placeholder="请选择状态"
                  >
                    <el-option label="全部" value></el-option>
                    <el-option label="启用中" :value="0"></el-option>
                    <el-option label="已停用" :value="1"></el-option>
                  </el-select>
                </el-form-item>
                <el-form-item>
                  <el-button size="small" @click="filterSearch">查询</el-button>
                  <el-button size="small" @click="resetfilter">重置</el-button>
                </el-form-item>
              </el-form>
            </el-col>
          </el-row>

          <flow-table
            @reloadList="queryCreate"
            :tableData="createTableData"
            :columns="createTableCol"
          />
          <p class></p>
        </el-tab-pane>
        <el-row class="pageation">
          <el-col :span="24" style="padding: 30px 0" class="page-flex-end">
            <el-pagination
              @size-change="handleSizeChange"
              @current-change="handleCurrentChange"
              :current-page="filterModel.page"
              :page-sizes="[10, 20, 50, 100]"
              :page-size="filterModel.pageSize"
              layout="sizes, prev, pager, next, total"
              :total="filterModel.pageTotal"
            />
            <el-go
              :page-size="filterModel.pageSize"
              :total="filterModel.pageTotal"
              @current-change="handleCurrentChange"
              style="margin-right: 5px"
            ></el-go>
          </el-col>
        </el-row>
      </el-tabs>
    </div>
  </div>
</template>

<script>
import FlowTable from "./FlowTable.vue";
import FlowHandles from "./FlowHandles.vue";
import useFileAuditFlag from "@/components/corp-comps/switch-btn";
import ElGo from "@/components/go/Go";
import { ApiCorpMethods } from "@/assets/js/http-serve/corp/http-methods";
import { gantConf, getPermInfo } from "@/assets/js/utils/jurisdiction";
import { isInDingTalk } from "@/assets/js/utils/ding-env";
import { dingtalkApi } from "../../../assets/js/http-serve/dingtalkApi";
import moment from "moment";
import { mapGetters } from "vuex";

// 状态 组件
let status = {
  render: function (createElement) {
    let data = this.data;
    return createElement("div", [
      createElement(
        "span",
        {
          style: {
            color:
              data.status === 1
                ? "#adadad"
                : data.status === 0
                  ? "#67C23A"
                  : "#Ec1c1c",
            marginRight: "5px"
          }
        },
        "●"
      ),
      createElement(
        "span",
        data.status === 1 ? "已停用" : data.status === 0 ? "启用中" : "已删除"
      )
    ]);
  },
  props: {
    data: {}
  }
};

//新增 审批流程列 21-03-23
let orderFlag = {
  render: function (createElement) {
    let data = this.data;
    let dingNodes = [];
    data.nodes.forEach(item => {
      item.userApproveUsers.forEach(user => {
        dingNodes.push(user.name);
      });
    });
    return createElement("div", [
      createElement(
        "span",
        (data.flowType === 1 ? "顺序审批：" : "会审：") + dingNodes.join(data.flowType === 1 ? '-->' : '、')
      )
    ]);
  },
  props: {
    data: {}
  }
};

export default {
  name: "flow",
  components: { FlowTable, ElGo, useFileAuditFlag },
  data () {
    return {
      isInDingTalk,
      gantConf,
      activeName: "create",
      tabPosition: "top",
      createFilter: {
        page: 1,
        pageSize: 10,
        pageTotal: 0,
        flowName: "",
        orderFlag: "",
        useStatus: ""
      },
      signFilter: {
        page: 1,
        pageSize: 10,
        pageTotal: 0,
        flowName: "",
        orderFlag: "",
        useStatus: ""
      },
      createTableData: [],
      createTableCol: [
        {
          prop: "flowName",
          label: "流程名称",
          width: "200",
          'show-overflow-tooltip': true
        },
        {
          prop: "orderFlag",
          label: "审批流程",
          slot: orderFlag,
          'show-overflow-tooltip': true
        },
        // {
        //   prop: "allCopyToName",
        //   label: "抄送人"
        // },
        // {
        //   prop: "allGroupName",
        //   label: "应用的部门"
        // },
        {
          prop: "_scopeOfUse",
          label: '已授权成员',
          'show-overflow-tooltip': true
        },
        {
          prop: "status",
          label: "启用状态",
          width: "100",
          slot: status
        },
        // {
        //   prop: "createTime",
        //   label: "创建时间",
        //   width: "160"
        // }
      ],
      signTableData: [],
      signTableCol: [
        {
          prop: "flowName",
          label: "流程名称"
        },
        {
          prop: "orderFlag",
          label: "审批流程",
          slot: orderFlag
        },
        {
          prop: "useStatus",
          label: "启用状态",
          width: "100",
          slot: status
        },
        {
          prop: "createTime",
          label: "创建时间",
          width: "160"
        },
        {
          prop: "useFileAuditFlag",
          label: "审批复用",
          width: "110",
          slot: useFileAuditFlag
        }
      ]
    };
  },
  created () {
    this.$nextTick(() => {
      this.operationAuthFn();
    });
  },
  mounted () {
    this.queryCreate();
  },

  methods: {
    //操作按钮权限
    operationAuthFn () {
      this.createTableCol.push({
        label: "操作",
        width: "140",
        slot: FlowHandles
      });
    },
    // 重置
    resetfilter () {
      this.filterModel.page = 1;
      if (this.activeName === "create") {
        this.createFilter = {
          page: 1,
          pageSize: 10,
          pageTotal: 0,
          flowName: "",
          orderFlag: "",
          useStatus: ""
        };
      } else {
        this.signFilter = {
          page: 1,
          pageSize: 10,
          pageTotal: 0,
          flowName: "",
          orderFlag: "",
          useStatus: ""
        };
      }
      this.filterSearch();
    },
    // 搜索按钮
    filterSearch () {
      this.filterModel.page = 1;
      this.queryCreate();
    },

    // 查询发起审批
    async queryCreate () {
      const dingtokenInfo = JSON.parse(sessionStorage.getItem("dingloginInfo"));
      const dingInfo = {
        corpId: dingtokenInfo.dingTalkCorpId,
        dingTalkUserId: dingtokenInfo.dingTalkUserId
      };
      let param = Object.assign(dingInfo, this.createFilter);
      dingtalkApi.flowlistByPage(param).then(res => {
        if (!res.success) return this.$message.error(res.description || "查询数据失败");
        this.createTableData = res.data;
        this.createTableData.forEach((item, i) => {
          const _size = 15;
          dingtalkApi.scopeuserlistByPage({
            corpId: dingtokenInfo.dingTalkCorpId,
            dingTalkUserId: dingtokenInfo.dingTalkUserId,
            flowId: item.flowId,
            page: 1,
            pageSize: _size
          })
            .then(result => {
              const user = result.data.map(v => {
                if (v.dingTalkUserName) return v.dingTalkUserName
              })
              if (result.total > _size) {
                user.push('...')
              }
              this.$set(this.createTableData[i], '_scopeOfUse', user.toString())
            })
        })
        this.createFilter.pageTotal = res.total;
        this.createFilter.pageSize = res.pageSize;
        this.createFilter.pageNum = res.pageNum;
        this.createFilter.pages = res.pages;
      })
    },
    // 查询盖章审批
    async querySign () {
      let param = Object.assign({}, this.signFilter, { flowType: 1 });
      let res = await ApiCorpMethods.FlowController.pageFlow(param);
      if (!res.success) {
        return this.$message.error(res.description || "查询数据失败");
      }
      this.signTableData = res.data;
      this.signFilter.pageTotal = res.total;
      this.signFilter.pageSize = res.pageSize;
      this.signFilter.pageNum = res.pageNum;
      this.signFilter.pages = res.pages;
    },
    addFlow () {
      // if (this.isCreate) {
      // 发起审批
      const bool = this.permsEven()
      if (!bool) return
      this.$router.push({
        path: "/console/dingComponents/approval",
        query: { flowType: 0 }
      });
      // }
      //  else if (this.isSign) {
      //   // 盖章审批
      //   this.$router.push({
      //     path: "/console/approval",
      //     query: { flowType: 1 }
      //   });
      // }
    },
    /** 权限验证 */
    permsEven (pid = gantConf.documentApproval) {
      const perms = this.perms;
      const bool = perms.includes(pid);
      if (!bool) {
        const Pinfo = getPermInfo(pid)
        this.$message.error(`暂无【${Pinfo.name}】权限，如需使用请联系管理员开通`)
      }
      return bool
    },
    handleSizeChange (val) {
      if (this.isCreate) {
        this.createFilter.page = 1;
        this.createFilter.pageSize = val;
        // 查询发起审批
        this.queryCreate();
      } else if (this.isSign) {
        this.signFilter.page = 1;
        this.signFilter.pageSize = val;
        // 查询盖章审批
        this.querySign();
      }
    },
    handleCurrentChange (val) {
      if (this.isCreate) {
        this.createFilter.page = val;
        // 查询发起审批
        this.queryCreate();
      } else if (this.isSign) {
        this.signFilter.page = val;
        // 查询盖章审批
        this.querySign();
      }
    },
  },
  computed: {
    ...mapGetters(["currentAuthUser"]),
    perms () {
      console.log(this.currentAuthUser.perms ? this.currentAuthUser.perms : []);
      return this.currentAuthUser.perms ? this.currentAuthUser.perms : [];
    },
    isCreate () {
      return this.activeName === "create";
    },
    isSign () {
      return this.activeName === "sign";
    },
    filterModel () {
      if (this.isCreate) {
        return this.createFilter;
      } else if (this.isSign) {
        return this.signFilter;
      }
    }
  }
};
</script>

<style lang="less" scoped>
.main-wrap {
  background: #ffffff;
  /*padding: 20px;*/
  /deep/ .el-tabs {
    .el-tabs__content {
    }
    .el-tabs__item.is-active {
      color: #ec1c1c;

      .faqi {
        background: url("/images/console/faqiHover.png") no-repeat;
        background-size: cover;
      }
      .yongyin {
        background: url("/images/console/yongyinHover.png") no-repeat;
        background-size: cover;
      }
    }
    .el-tabs__active-bar {
      height: 0 !important;
      background: transparent;
    }
    .el-tabs__item {
      text-align: left;
      padding: 0 40px 0 20px !important;
      &:hover {
        color: #ec1c1c;
      }

      .faqi {
        display: inline-block;
        width: 15px;
        height: 15px;
        margin-right: 20px;
        background: url("/images/console/faqi.png") no-repeat;
        background-size: cover;
      }
      .yongyin {
        display: inline-block;
        width: 15px;
        height: 15px;
        margin-right: 20px;
        background: url("/images/console/yongyin.png") no-repeat;
        background-size: cover;
      }
    }
    .el-tabs__active-bar {
      width: 136px !important;
    }
  }
}
/deep/ .el-tabs--left .el-tabs__header.is-left {
  padding-top: 30px;
  position: absolute;
  top: 0;
  left: 0;
  bottom: 0;
  border-right: 15px solid #f5f5f5;
}
/deep/ .el-tabs__nav-wrap::after {
  display: none;
}
.org-tree {
  position: relative;
  background: #ffffff;
  min-height: 30px;
  margin-top: 15px;
}

/deep/ .el-tab-pane {
  padding: 20px 15px 0;
}
</style>



// WEBPACK FOOTER //
// pages/console/dingComponents/dingFlow.vue